import { ProductType } from "src/types/product-types/ProductType";

export const descriptions = [
  {
    type: ProductType.Underwear,
    description: "underwear_description",
  },
  {
    type: ProductType.WashBag,
    description: "wash_bag_description",
    features_title: "wash_bag_features_includes",
    features: [
      "wash_bag_feature_1",
      "wash_bag_feature_2",
      "wash_bag_feature_3",
      "wash_bag_feature_4",
    ],
    dimensions: "wash_bag_dimensions",
  },
  {
    type: ProductType.TravelBag,
    description: "travel_bag_description",
    dimensions: "travel_bag_dimensions",
  },
  {
    type: ProductType.GiftCard,
    descriptions: [
      "gift_card_description1",
      "gift_card_description2",
      "gift_card_description3",
    ],
    uses_title: "gift_card_uses_title",
    uses: [
      "birthdays",
      "valentines_day",
      "mothers_day",
      "anniversaries",
      "bridal_showers",
      "just_because",
    ],
    additionalInformation: [
      "not_a_physical_product",
      "only_online_payment",
      "gift_cards_redemption",
    ],
  },
];
